var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenMtnBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 912,
    height: 739,
    viewBox: "0 0 912 739",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 738H404H866L404 296.83C352.368 235.56 302.17 271.301 283.525 296.83L4.07611 731.429L0 738H144Z",
    fill: "#005056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355 442.5L668.5 738.428L404.275 738.428L167 738.428L355 442.5Z",
    fill: "#D6FC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158 507.5L0 281V736H13L158 507.5Z",
    fill: "#D6FC47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.333 526L0 285.136V59C0 59 4.0675 59.8424 11.1102 63.7584C17.6856 66.704 27.7319 74.936 30.8365 78.2601C37.1852 85.0577 57.3933 115.251 57.3933 115.251L81.6827 150.202L130.262 220.105L227.419 359.91L239.21 378.264L251 395.711L235.128 420.636L208.6 460.289L167.333 526Z",
    fill: "#005056"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMtnBackground);
export default __webpack_public_path__ + "static/media/green-mtn-background.6b02976b5a650b62e6451ec7af2eb0a3.svg";
export { ForwardRef as ReactComponent };